import api from '@/models/api';

export enum SettingNamespace {
    GENERAL = 'general',
    OPENINGS = 'openings',
    ORDERS = 'orders',
    PRINTER = 'printer',
    CONTENT = 'content',
    PAYMENT = 'payment',
}

export interface SettingInterface {
    name: string;
    namespace: SettingNamespace;
    value: any;
}
export default class Settings {
    private settings: SettingInterface[] = [];
    private static _instance?: Settings;

    private constructor(settings: SettingInterface[]) {
        for (let index = 0; index < settings.length; index++) {
            settings[index].value = JSON.parse(settings[index].value);
        }
        this.settings = settings;
    }

    public static async getInstance(): Promise<Settings> {
        if (Settings._instance === undefined) {
            const settings = await api.get<SettingInterface[]>({ name: 'settings.index' });
            if (settings.success) {
                Settings._instance = new Settings(<SettingInterface[]>settings.content);
            }
        }
        return <Settings>Settings._instance;
    }

    public get(namespace: SettingNamespace, name: string) {
        return this.settings.find((setting: SettingInterface) => setting.namespace === namespace && setting.name === name);
    }
}
